import React from "react";
import { Link } from "react-router-dom";
import "./VisitaDetailPage.css";

const VisitaAudiologicaPage: React.FC = () => {
  return (
    <div className="visita-detail-page">
      {/* Header Section */}
      <section className="visita-detail-header">
        <div className="visita-detail-header-container">
          <p className="visita-detail-label">VISITE SPECIALISTICHE</p>
          <h1 className="visita-detail-title">Visita Audiologica</h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="visita-detail-content">
        <div className="visita-detail-container">
          <img
            src={require("../assets/carousel/PHOTO-2025-10-16-20-09-03 3.jpg")}
            alt="Visita Audiologica"
            className="visita-detail-image"
          />

          <div className="visita-detail-text">
            <h2 className="visita-detail-subtitle">
              Valutazione completa dell'udito
            </h2>
            <p className="visita-detail-paragraph">
              La visita audiologica é una prestazione specialistica utile per
              valutare la funzionalità dell’orecchio e la capacità uditiva.
              Comprende oltre che l’anamnesi, l’esame obiettivo (otoscopia),
              l’esame audiometrico e l’impedenzometria.
            </p>

            <div className="visita-detail-cta">
              <Link to="/#prenota" className="btn-primary">
                Prenota la Visita
              </Link>
              <Link to="/visite" className="btn-secondary">
                Torna alle Visite
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VisitaAudiologicaPage;
